import http from './http'
import { Address } from '@/models/Address'

class GeoNorge {

  public searchByQuery(query: string, municipalityNumber: string = '') {
    let params = 'sok=' + encodeURIComponent(query + '* ' + query)
    // let params = 'sok=' + encodeURIComponent(query)
    if (municipalityNumber) {
      params += '&kommunenummer=' + encodeURIComponent(municipalityNumber)
    }
    return this.search(params)
  }

  public searchByNumbers(municipalityNumber: string, buildingNumber: string, unitNumber: string) {
    let params = ''
    params += 'kommunenummer=' + encodeURIComponent(municipalityNumber)
    params += '&gardsnummer=' + encodeURIComponent(buildingNumber)
    params += '&bruksnummer=' + encodeURIComponent(unitNumber)
    return this.search(params)
  }

  private search(params: string) {
    return new Promise<Address[]>((resolve, reject) => {
      const url = 'https://ws.geonorge.no/adresser/v1/sok?treffPerSide=100&side=0&' + params
      http.get(url)
        .then((response: any) => {
          const items: Address[] = []
          const data = response && response.data && response.data.adresser ? response.data.adresser : []
          data.forEach((res: any) => {
            items.push(this.toAddress(res))
          })
          resolve(items)
        })
        .catch((err: Error) => {
          reject(err)
        })
    })
  }

  private toAddress(res: any) {
      const item = new Address()
      item.streetAddress = res.adressetekst
      item.postalCode = res.postnummer
      item.city = res.poststed
      item.municipalityNumber = res.kommunenummer
      item.buildingNumber = res.gardsnummer
      item.unitNumber = res.bruksnummer
      item.name = item.streetAddress
      item.fullId = JSON.stringify(item)
      // item.fullText = item.streetAddress + ( item.name ? ' - ' + item.name : '' )
      item.fullText = item.streetAddress
      return item
  }

}

const geonorge = new GeoNorge()

export default geonorge
